import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import { toast } from "react-hot-toast";
import { useCallback } from "react";
import { loadFull } from "tsparticles";
import Particles from "react-tsparticles";

const Contact = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_rahat",
        "template_26dt6ap",
        form.current,
        "VuTFshyCEJDani1hS"
      )
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          toast.success("Message sent successfully");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <section>
      <div className="h-[100vh] grid grid-cols-12 !mt-[283px]">
        <div className="bg-slate-900 lg:col-span-9 col-span-12 relative">
          <div
            className="text-white flex items-center justify-center flex-col w-11/12 md:!-translate-x-1/2 md:!-translate-y-1/2"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%,-32%)",
            }}
          >
            <p className="lg:max-w-md w-11/12">
              If you are interested in working together, Please fill out the
              form below with some info about your project and I will get back
              to you as soon as I can
            </p>
            <form
              className="xl:w-1/2 lg:w-4/6 w-5/6 mt-8 grid grid-cols-1 gap-6"
              ref={form}
              onSubmit={sendEmail}
            >
              <div>
                <input
                  className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary bg-transparent"
                  type="text"
                  name="fName"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div>
                <input
                  className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary bg-transparent"
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                />
              </div>
              <div>
                <input
                  className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary bg-transparent"
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  required
                />
              </div>
              <div>
                <textarea
                  className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary bg-transparent"
                  type="text"
                  name="message"
                  placeholder="Message"
                  required
                />
              </div>
              <button
                className="contact-btn xl:mt-8 mt-4 mb-5"
                style={{ "--clr": "#0FF0FC" }}
              >
                <span>Send Message</span>
                <i></i>
              </button>
            </form>
          </div>

          <Particles
            className="lg:h-[100vh] h-[50vh]"
            id="tsparticles2"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              background: {
                color: {
                  value: "#0F172A",
                },
              },
              fullScreen: {
                enable: false,
                zIndex: -1,
              },
              fpsLimit: 120,
              interactivity: {
                events: {
                  onClick: {
                    enable: true,
                    mode: "push",
                  },
                  onHover: {
                    enable: true,
                    mode: "repulse",
                  },
                  resize: true,
                },
                modes: {
                  push: {
                    quantity: 4,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                },
              },
              particles: {
                color: {
                  value: "#ffffff",
                },
                links: {
                  color: "#ffffff",
                  distance: 150,
                  enable: true,
                  opacity: 0.5,
                  width: 1,
                },
                collisions: {
                  enable: true,
                },
                move: {
                  directions: "none",
                  enable: true,
                  outModes: {
                    default: "bounce",
                  },
                  random: false,
                  speed: 2,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    area: 2800,
                  },
                  value: 80,
                },
                opacity: {
                  value: 0.5,
                },
                shape: {
                  type: "circle",
                },
                size: {
                  value: { min: 1, max: 5 },
                },
              },
              detectRetina: true,
            }}
          />
        </div>
        <div className="bg-secondary h-full order-first lg:order-last lg:col-span-3 col-span-12 text-white flex items-center justify-center">
          <p className="lg:rotate-90 text-6xl font-bold uppercase lg:tracking-widest">
            Contact
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
